import { Images } from '@business/assets/images';
import { SVGAssets } from '@business/assets/vectors';
import { BackToWebsite } from '@business/workflows/ComponentViews/SignIn/BackToWebsite';
import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthLayoutProps {
  children?: ReactNode;
  isSignUp?: boolean;
}

export const AuthLayout: FC<AuthLayoutProps> = ({ isSignUp, children }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex relative overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 signup-bg z-0 pointer-events-none"
        style={{
          backgroundImage: `url(${Images.BgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      {/* Back Arrow Button */}
      <button
        onClick={handleGoBack}
        className="absolute top-4 left-4 md:top-10 md:left-10 z-20 w-12 h-12 md:w-16 md:h-16 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer">
        <SVGAssets.ArrowLeftIcon className="w-4 h-4 md:h-6 text-white" />
      </button>

      {/* Main Content */}
      <div className="flex flex-1 items-center justify-center p-4 md:p-6 relative z-10">
        <div className="w-full max-w-sm md:max-w-md bg-white rounded-[64px] p-6 md:p-8 relative signup-form-card shadow-lg">
          {isSignUp && <BackToWebsite />}
          <div className="flex">
            <img
              src={Images.KinshipLogo}
              alt="Kinship Logo"
              className="w-24 h-16 md:w-32 md:h-20 object-contain"
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
